import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';

require('./style.css');

interface IProps {
	currentStep: number;
	numberOfSteps: number;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class WizzardSteps extends React.Component<IProps, any> {
	public render() {
		const { currentStep, numberOfSteps } = this.props;

		const steps = [];

		let i: number;
		for (i = 1; i <= numberOfSteps; i++) {
			if (i === 1) {
				steps.push(<div key={'wizzard_step_' + i} className={`step stepFirst ${currentStep < i ? '' : 'active'}`} />);
			} else {
				steps.push(<div key={'wizzard_step_' + i} className={`step ${currentStep < i ? '' : 'active'}`} />);
			}
		}

		return (
			<div className="wizzardSteps">
				<span className="stepsTitle">
					{currentStep}/{numberOfSteps}
				</span>
			</div>
		);
	}
}

export { WizzardSteps };
